import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';

const defaultStyle = {
    background: 'transparent',
    padding: '0',
    margin: '0 auto',
    border: 'none',
    borderRadius: '0',
};

const PageConPc = dynamic(() => import('@/components/productSmart/smartgenerator/indexDynamic'), {
    ssr: true,
});

export default function SmartGenerator({ cssStyle }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { useLang } = useGlobal();
    const { t } = useLang('smartgenerator');
    const bannerData = [
        {
            bgImgs: ['1_main.webp', '1_main.jpg'],
            title: t('smart_generator.title'),
            des: t('smart_generator.subtitle'),
            // logo_url: '/img/logo-white.png',
        },
    ];

    return (
        <div
            className={`${css.smartgenerator} SmartGeneratorModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <div style={{ width: '100%', marginTop: '-64px' }} className="bannerModule1">
                <BannerModule data={bannerData} config={{ titleColor: '#fff', desColor: '#fff', webpUrl: '/media/smartgenerator/pc/' }} theme={'black'} />
            </div>
            <PageConPc />
        </div>
    );
}
